module.exports = __webpack_public_path__ + "img/Seite25-papa.02e85daa.png";